const ApplicationName = 'Billing';

const Links = Object.freeze({
    billing: 'Billing Tile Clicked',
    billingSummary: 'Billing Summary',
    downloadCSV: 'Download CSV File',
    downloadCSVLegacy: 'Download CSV File for Legacy',
    downloadPDF: 'Download PDF File',
    enquiryForm: 'Enquiry Form',
    threeDotsLegacy: 'Three Dots Clicked For Legacy',
    threeDotsStrategic: 'Three Dots Clicked For Strategic',
    banIdSelectFromDropDownLegacy: 'Billing Account Number Selected For Legacy From DropDown',
    banIdSelectFromDropDownStrategic: 'Billing Account Number Selected For Strategic From DropDown',
    banIdSelectedFromDropDown: 'Billing Account Number Got Selected From DropDown',
    enquiryOpenState: 'User opens new enquiry',
    enquiryCancelState: 'User cancels enquiries on ',
    drilldownLinkClicked: 'User lands on ',
    breadCrumbClicked: ' User lands on ',
    downloadCSVFails: 'Download CSV file fails.',
    downloadInvoiceCSVSuccess: 'Download CSV file Success.',
    downloadPDFFails: 'Failure',
    downloadPDFSuccess: 'Success',
    downloadSuccessText: 'Success',
    showMoreInvoiceNumber: 'User clicks to expand the invoice number list when multiple invoice numbers are present ',
    showLessInvoiceNumber: 'User clicks to close the accordion of invoice numbers ',
    alertBannerClicked: 'User clicks to close the alert banner',
    BillingAccountChangeClick: 'User selects \'Request a billing account change\' option',
    invoiceLinkClicked: 'User clicks on invoices link',
    enquiriesLinkClicked: 'User clicks on enquiries link',
    footerLinkClicked: 'User clicks on view invoices link',
    HeaderLinkClicked: 'User clicks on Billing tile title',
    tAnalystLinkClicked: 'User clicks on T- Analyst link',
    creditDebitTransfers: 'User selects \'Request a credit/debit transfers\' option',
    otherBillingEnquiry: 'User selects \'Other billing enquiry\' option',
    queryInvoicedCharge: 'User selects \'Query an invoiced charge\' option',
    supportEnquiriesClicked: 'User clicks on support enquiries link',
    radiobuttonClicked: 'User clicks on radio button',
    newEnquiryCancelClick: 'User clicks cancel when on invoices tab and radio buttons are displayed',
    newEnquiryContinueClick: 'User clicks continue when on invoices tab and radio buttons are displayed',
    enquiryFirstOptionClicked: 'User clicks on the Queried an invoice Charge option in the dropdown when on ',
    sendButtonClicked: 'User clicks on \'Send\' button after adding a new comment at enquiry details page.',
    attachButtonClicked: 'User clicks on \'Attach\' button after adding an attachment at enquiry details page.',
    enquiryFormattachments: 'User adds attachment to ',
    tAnalystContinueClick: 'User clicks continue from T-Analyst',
    summaryTabClick: 'User clicks on enquiry details summary tab',
    queryChargeTabClick: 'User clicks on enquiry details queried charges tab',
    enquiryLinkClick: 'User clicks on any enquiries number in the new blue box on the summary invoice.',
    attachmentTypeClickedToDownload: (attachType: string) => ` to download ${attachType}`,
    downloadPDFOnInvoiceList: 'User clicks on download PDF link on Invoice list page',
    downloadSuccess: 'Download successful',
    downloadFailure: 'Download failed',
    downloadCSVQueriedCharge: 'User clicks on download CSV which is on Queried charges tab',
    downloadCSVOnEnquiryList: 'User clicks on download CSV link on enquiry list page',
    downloadCSVSuccess: 'User successfully downloaded csv',
    legacyDownloadCSVSuccess: 'Legacy User successfully downloaded csv',
    downloadCSVFailure: 'Csv download failed',
    legacyDownloadCSVFailure: 'Csv download failed for legacy user',
    olderInvoiceBillingAccountClicked: 'user selects a different account number from the billing account drop-down',
    olderInvoiceFilterOptionClicked: 'user clicks on the filter icon',
    olderInvoiceEditFilterOptionClicked: 'user clicks on the edit filter icon',
    olderInvoiceFilterMultipleOptionClicked: 'user clicks on the multiple invoices tab in the filter component',
    olderInvoiceFilterSingleOptionClicked: 'user clicks on the single invoice tab in the filter component',
    olderInvoiceSingleDatePickerClicked: 'user adds a date in the single date picker',
    olderInvoiceMultipleFromDatePickerClicked: 'user adds a \'from\' date in the multiple date picker',
    olderInvoiceMultipleToDatePickerClicked: 'user adds a \'to\' date in the multiple date picker',
    olderInvoiceCancelLinkClicked: 'user clicks on the cancel link from filter section',
    olderInvoiceNewEnquiryLinkClicked:
        'user clicks the \'new enquiry\' link from the additional line of text above the table',
    olderInvoiceApplyFilterLinkClicked: 'user clicks on the apply filter link from filter section',
    eftEmailLinkClicked: 'User clicks on eft email link',
    continueClick: 'User clicks on continue',
    viewOlderInvoiceClick: 'User views the older invoice page',
    TAnalystGoToDashboard: 'User clicks on the button to go to the dashboard',
    ReportAnErrorButton: 'User clicks on the report an error button',
    NavigatedBackToInvoiceDetails: 'User navigated back to invoice details from Payment/credit Page',
    downloadZIP: 'Download ZIP File',
    downloadZIPSuccess: 'Download Detailed Charges CSV - Success',
    downloadZIPFails: 'Download Detailed Charges CSV - Failure',
    detailedChargesCsv: 'Detailed Charges CSV',
    detailedChargesCsvUsage: 'Detailed Charges with $0 usage CSV',
    editFilterLink: 'User clicked on edit filter',
    canceledEditFilterLink: 'User clicked on cancel filter on edit mode',
    appliedEditFilterLink: 'User clicked on applied filter on edit mode',
    crossOnPillLink: 'User clicked on clear button',
    newBadgeAtInvoicePage: 'user clicks the new badge on the invoices tab',
    newBadgeDismissInvoicePage: 'user clicks to dismiss the tooltip popup',
    goBack: 'User go back to direct debit page',
    submitBug: 'User clicked on the report submit a bug',
    eftPayment: 'user clicks the email address for EFT payment',
    viewDirectDebitServiceAgreement: 'the user clicks the link to view direct debit service agreement',
    cancelDirectDebit: 'the user clicks on cancel at direct debit form',
    setupDirectDebit: 'the user clicks the link to set up direct debit',
    setupDirectDebitLegacy: 'the user clicks on the internet link to direct debit',
    switchAccount: 'user switches between account numbers',
    switchCompany: 'user switches between companies',
    NewLiteral: 'User clicked on view details link',
    successfulCreditCardPayment: 'when the user clicks credit card payment and it is successfully sent',
    successfulBankAccountPayment: 'when the user clicks bank account payment and it is successfully sent',
    billingDownloadZip: 'Download Detailed Charges CSV',
    billingAllDownloadZip: 'Download Detailed Charges + All Usage CSV',
    billingDownloadLegacyPDF: 'Download Tax Invoice PDF',
    pdfFailureLink: ' - PDF Failure - Go to FAQs - Legacy',
    updatePaymentDetails: 'user clicks on update payment details',
    removeDirectDebit: 'user clicks on remove direct debit',
    cancelDirectDebitLink: 'user clicks on cancel direct debit',
    consentCheck: ' - Attachment Consent',
    ddRaiseAnEnquiry: '- Raise TC Enquiry',
    ddPrivacyPolicy: '- View Privacy Statement',
    ddtermsAndCondition: '- View TC Terms and Conditions',
    trackBillingEnquiries: ' - Track billing Enquiries',
    caseNumberLink: ' - Case Number Link',
    payByCreditCard: ' - Pay by Credit Card',
    creditCardFormCancel: '- Cancel',
    creditCardFormDisplay: '- Display',
    creditCardFormContinue: '- Continue',
    payByCCInvoiceList: ' - Pay by CC Via Invoices List',
    bPayToInvoices: 'PaymentsMethodPage BPAYSection To InvoicesPage',
    payByCCLegacy: ' - Pay by CC Via Telstra.com - Legacy',
    submitBugPayByCredit: '- Submit Bug',
    goBackPayByCredit: '- Go Back',
    payByCCSuccess: '- Payment Success',
    payNowFailure: '- Pay now - Failure',
    payNowSuccess: '- Pay now - Success',
    successText: 'Success',
    successConfirmToInvoice: 'Back to Invoices',
    successConfirmToPayHistory: 'Payment History',
    clickPaymentOption: 'Click Payment Options',
    clickOncloseBanner: ' - Close Billing Banner - All',
    newBadgeForPaymentOptions: 'Invoice List-Open Payment Options New Badge-All',
    newBadgeDismissForPaymentOptions: 'Invoice List-Close Payment Options New Badge-All',
    directDebitStatusreportAnError: 'Direct Debit Status - Report Error',
    directDebitStatusRetry: 'Direct Debit Status - Retry',
    removeDDLink: 'Remove DD',
    cancelRemoveDDLink: 'Cancel Removal of DD',
    editSuccessfully: ' - Edit Method - Success',
    addpaymentMethodSuccess: 'Add Method - Success',
    addpaymentMethodFailed: 'Add Method - Failure',
    deleteSuccessfully: ' - Delete Method - Success',
    editFailure: ' - Edit Method - Failure',
    deleteFailure: ' - Delete Method - Failure',
    payByCreditCardLegacy: ' Pay By Card - Legacy',
    raiseSupportEnquiry: ' Raise a support enquiry',
    changeCompany: ' Changed company',
    changeBillingAccount: ' Changed billing account',
    breadcrumbTelstraConnect: ' Clicked on Telstra Connect link from breadcrumb',
    breadcrumbBilling: ' Clicked on Billing link from breadcrumb',
    updateDirectDebitClicked: 'User clicks on update direct debit submit',
    addDirectDebitClicked: 'User clicks on add direct debit submit',
    singleViewInvoiceClicked: 'single View InvoiceSummary to Invoicedetails'
});

const Components = Object.freeze({
    dashboardPage: 'Navigated to dashboard',
    reportAnError: 'User lands on Report an Error Page',
    billingSummaryPage: 'Billing Summary Page',
    summaryInvoicePage: 'Billing Summary Page',
    billingExportInvoiceSummary: 'Invoice List - Export table',
    billingExportAdjustmentSummary: 'Click on Download report button on Adjustments Tab in Billing Summary Page/',
    billingExportPaymentSummary: 'Click on Download report button on Payments Tab in Billing Summary Page/',
    billingDownloadInvoiceDetailsPDF: 'Summary Invoice - Download Tax Invoice PDF',
    billingDownloadInvoiceSummaryCSV: 'Click on Download CSV Button on Billing Invoice Summary Page/',
    billingSummaryInvoiceList: 'Click on row on Invoices List under Invoices Tab',
    billingSummaryPaymentsList: 'Click on row on Payments List under Payments Tab',
    billingSummaryEnquiryList: 'Click on row on Enquiry List under Enquiry Tab',
    billingDownloadMDMPostbillCSV: 'Click on Download CSV Button on MDM Post bill Details Page/',
    billingDownloadInvoiceListPDFLegacy: `Invoice List - Download Tax Invoice PDF`,
    billingDownloadFileDownloadPanelPDFLegacy: 'Click on File name on file download panel for Legacy/',
    billingDownloadInvoiceListPDF: 'Invoice List - Download Tax Invoice PDF',
    billingDownloadPDF: (page: string) => `Click on row on Download PDF Button on Billing ${page} Page for Strategic/`,
    billingDownloadInvoiceListCSV: 'Invoice List - Download Summary CSV',
    billingSummaryInvoiceTab: 'Click on Invoices Tab/',
    billingSummaryPaymentsTab: 'Click on Payments Tab/',
    billingSummaryCreditTab: 'Click on Credit Adjustment Tab/',
    billingSummaryEnquiryTab: 'Click on Enquiry Tab/',
    billingDownloadDrillDownCSV: (recurringType: string) => `Invoice Details ${recurringType} - Download CSV `,
    billingRaiseEnquiry: 'Click on New enquiry Button on ',
    billingCancelEnquiry: 'Click on Cancel enquiry Button on ',
    billingDrilldownLink: 'Click on Drilldown page link for ',
    billingBreadCrumb: 'Click on Billing bread crumb from ',
    billingInvoiceBreadCrumb: 'Click on Invoice bread crumb',
    billingDrilldownAccordionRowClick: 'user clicks on accordion arrow to ',
    billingMinimumSpendTooltipClick: 'user clicks on tooltip present for a minimum spend commitment row on ',
    accordianHeaderTooltipClick: 'user clicks on tooltip next to ',
    alertBannerClick: 'User clicks on alert banner',
    newEnquiryDropdownClick: 'User clicks on new enquiry dropdown',
    radioButtonNewEnquiry: 'User makes a selection using radio buttons',
    newEnquiryCancel: 'User clicks cancel from new enquiry sticky header',
    newEnquiryContinue: 'User clicks continue from new enquiry sticky header',
    invoiceTab: 'invoices tab',
    paymentTab: 'payments tab',
    creditTab: 'credit adjustments tab',
    enquiryTab: 'enquiries tab',
    enquiryDetails: 'enquiries details',
    enquiryForm: 'enquiry form',
    tAnalystContinue: 'Billing T-Analyst',
    enquiryTabComponent: 'User clicks on enquiry details tab',
    enquiryLink: 'Enquiry link on summary invoice page',
    downloadAttachmentDomestic: 'Clicked on download domestic attachment',
    downloadCSVOnQueriedChargeTab: 'Download summary link on queried charges tab',
    downloadCSVOnEnquiryList: 'Download csv link on enquiry list page',
    invoiceOlderThanEighteenMonths: 'Invoices older than 18 months',
    warningComponent: 'On Selection lost Warning component',
    openWarningComponent: 'User opens warning component',
    closeWarningComponent: 'User closes warning component',
    newEnquiryAtBottomComponent: 'User clicks new enquiry link at the bottom of page',
    invoiceNumberOnPaymentDetails: 'User clicks on invoice number inside payment details',
    invoiceNumberOnAdjustmentDetails: 'User clicks on invoice number inside credit adjustment details',
    backButtonClick: 'User clicks on back link ',
    TAnalystGoToDashboard: 'User clicks on the button to go to the dashboard in the error screen',
    billingDetailedChargesCsv: (page: string) => `Click on Billing ${page} Page for Strategic/`,
    olderInvoiceListFilter: 'Old Invoice List: ',
    paymentOptionButton: 'Click on Payment option button/',
    paymentHistoryStrategic: 'Clicks on Payment History tile from',
    paymentOptions: 'Strategic Payment options form',
    paymentOptionsLegacy: 'Legacy payment options form',
    newBadgeAtInvoicePage: 'New Badge',
    newBadgeDismissInvoicePage: 'New Badge Dismiss',
    setupDirectDebitForm: 'Setup Direct Debit Form',
    updateDirectDebitForm: 'Update Direct Debit Form',
    billingDownnloadZip: 'File Panel -',
    invoiceList: 'Billing: Invoice List',
    paymentOptionsPage: 'Payment Options Page',
    paymentOptionsModal: 'Payment Options Page Modal',
    invoiceSummaryModal: 'Summary Invoice Modal',
    invoiceSummaryPage: 'Summary Invoice',
    QueryCharge: 'Query an Invoiced Charge',
    billingEnquiryDetailsQueryPerPage: 'Enquiry Details - Change Number of Displayed Queried Items',
    billingEnquiryDetailsQueryParticularPage: 'Enquiry Details - Display Particular Queried Items Page',
    billingDDServiceAgreement: 'DD Service Agreement',
    billingEnquiryConfirmation: 'Enquiry Confirmation Page',
    invoicesTab: 'Invoices Tab',
    payByCreditCardForm: 'Credit Card Payment Form',
    creditCardFormPopup: 'Credit Card Form Popup',
    creditCardPaymentError: 'Credit Card Payment Error',
    creditCardPaymentSuccess: 'Credit Card Payment Success',
    payByCreditCard: 'Credit Card Payment',
    creditCardConfirm: 'Credit Card Confirmation',
    billingExportOldInvoice: 'Older Invoice List - Export Table',
    creditCardPayOptionClick: 'Credit Card Payment Form',
    selectItemPerPageDropdown: 'Change Number of Displayed Queried Items',
    selectLiterals: 'Display Particular Queried Items Page',
    enqAttachmentDownloadFailure: 'Enquiry Details-Unauth. Attachment Download Attempt',
    PaymentMethods: 'Payment Methods',
    paymentOptionsData: 'Payment Options',
    savedPaymentMethod: ' Saved Payment Methods',
    invoiceListTxt: ' Invoice List',
    trackEnquiry: 'Help and Support - click on track enquiry',
    trackBillingEnquiry: 'Help and Support - click on track billing enquiry',
    faq: 'Help and Support - click on Frequently asked questions',
    billingSummaryInvoiceTile: 'Click on Invoices tile from',
    LatestInvoicesTile: 'Click on Latest invoices tile from',
    ArchivedInvoicesTile: 'Click on Archived invoices tile from',
    CreditAdjustmentsTile: 'Click on Credit adjustments tile from',
    GetTAnalystReportsTile: 'Click on Get T Analyst reports tile from',
    YouAreLeavingTelstraConnect: ' You are leaving Telstra Connect modal'
});

const Page = Object.freeze({
    billingCreditAdjustmentDetailsPage: 'Inside Credit Adjustment Page',
    billingPaymentDetailsPage: 'Inside Payment Details Page',
    billingFeaturePackDetailsPage: 'Inside Feature Pack Details Page',
    billingRecurringChargeDetailsPage: 'Inside Recurring charge Details Page',
    billingDrillDownPage: 'Details Page type ',
    billingEnquiryDetailsPage: 'inside Enquiry Details Page',
    billingEnquiryListPage: 'inside Enquiry List Page',
    billingSummaryInvoicePage: ' inside Summary invoice page',
    billingEnquiryForm: 'inside strategic enquiry form',
    billingNewDigitalManagedServices: 'Digital managed services page',
    trackSupportEnquiries: 'Track enquiries page',
    paymentOptionsLegacy: 'Legacy payment options page',
    paymentOptions: 'Payment options page',
    billingLandingPage: 'Landing Page',
    billingSavedPaymentMethod: '- Display Saved Methods',
    billingAddNewPaymentMethod: '- Display Add New Payment Methods',
    billingNewLandingPage: ' Billing Landing Page',
    billingNewSummaryInvoicePage: ' inside new Summary invoice page',
    billingLegacySummaryInvoicePage: ' inside Legacy Summary invoice page',
    billingNewArchivedInvoicesPage: 'archived invoices page',
    billingNewLatestInvoicesPage: 'latest invoices page',
    billingNewCreditsAdjustmentPage: 'credits adjustment page',
    billingNewPaymentHistoryPage: 'Payment history page',
    billingNewEnquiryPage: 'Enquiry page',
    invoiceTableSingleView: 'Invoice table single view',
});
const Buttons = Object.freeze({
    EnquiryForm: 'Click on Enquiry Submit Form',
    ThreeDotsLegacy: 'Click on Three Dots for Legacy',
    ThreeDotsStrategic: 'Click on Three Dots for Strategic',
    EnquiryFormDms: 'Click on New enquiry button for digital managed services',
    trackSupportEnquiries: 'user clicks on track support enquiries button',
    YourTelstraToolsExplained: 'Click on Your Telstra Tools explained button from',
    DateFilter: '- Apply date filter',
    Cancel: 'Click on Cancel button from',
    Continue: 'Click on Continue button from',
    BillingAccountFilter: ' - Apply billing account filter'
})

export {
    ApplicationName,
    Components,
    Links,
    Buttons,
    Page
};
